import { ReactNode } from "react";
import Swimlane from "../../../../common/core-ui/Swimlane.tsx";
import styles from "./AssetSwimlane.module.scss";
import { clsx } from "clsx";

export default function AssetSwimlane({ children }: { children: ReactNode }) {
  return (
    <Swimlane
      className={clsx(styles.swimlane, "vst-book-card-group-vertical")}
      scrollMargin={10}
    >
      {children}
    </Swimlane>
  );
}
